import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '@env';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class BaseService {
  protected apiUrl = environment.apiUrl;

  constructor(private http: HttpClient, private router: Router) {}

  private getHeaders(): { headers: HttpHeaders } {
    const token = localStorage.getItem('accessToken');
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    let headers = new HttpHeaders();

    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
      headers = headers.set('X-Timezone', timeZone);
    }

    return { headers: headers };
  }

  get<T>(endpoint: string): Observable<any> {
    return this.http
      .get(`${this.apiUrl}/${endpoint}`, this.getHeaders())
      .pipe(catchError(this.apiErrorHandler));
  }

  post<T>(endpoint: string, data: any): Observable<any> {
    return this.http
      .post<T>(`${this.apiUrl}/${endpoint}`, data, this.getHeaders())
      .pipe(catchError(this.apiErrorHandler));
  }

  put<T>(endpoint: string, data: any): Observable<any> {
    return this.http
      .put<T>(`${this.apiUrl}/${endpoint}`, data, this.getHeaders())
      .pipe(catchError(this.apiErrorHandler));
  }

  delete<T>(endpoint: string): Observable<any> {
    return this.http
      .delete<T>(`${this.apiUrl}/${endpoint}`, this.getHeaders())
      .pipe(catchError(this.apiErrorHandler));
  }

  private apiErrorHandler = (response: Response) => {
    switch (response.status) {
      case 401: // Unauthorized
      case 429: // Too Many Requests
      case 403: // Forbidden
        localStorage.clear();
        sessionStorage.clear();

        this.router.navigate([
          '/' + this.router.url.split('?')[0].split('/').filter(Boolean)[0],
        ]);
        break;
      case 500: // Internal Server Error
      case 503: // Service Unavailable
        break;
      default:
        break;
    }

    return throwError(response);
  };
}
